import { action, computed, makeAutoObservable, observable } from "mobx";
import { SelectorItem } from "../common/selector-store";
import DictionariesService from "../../services/dictionaries";
import Subjects from "../../models/subjects";

export interface DepsDictionary {
    id: string;
    name: string;
    items: SelectorItem[];
}

class SelectorValues {

    @observable
    items: SelectorItem[];
    selectedItem: string;

    constructor() {
        this.items = [];
        this.selectedItem = "";

        makeAutoObservable(this);
    }

    @action
    selectItem(value: string): void {
        this.selectedItem = value;
    }

    @action
    setValues(values: SelectorItem[]): void {
        this.items = values;
        if (values.length === 1) {
            this.selectedItem = values[0].id;
        } else {
            this.selectedItem = "";
        }
    }

    @action
    reset(): void {
        this.selectedItem = "";
    }

    @action
    selectFirst() {
        this.selectedItem = this.items[0].id;
    }

    get selectedItemAsNumber(): number | null {
        return this.selectedItem === "" ? null : Number(this.selectedItem);
    }

    get selectedItemValue(): string {
        if (this.selectedItem === null) return '';

        return this.items
            .filter(item => this.selectedItem === item.id)
            .map(item => item.name)[0];
    }
}

export default class NumberInKimWithThemeStore {

    dictionariesService: DictionariesService;
    numberWithThemesMap: DepsDictionary[];

    @observable
    numberInKim: SelectorValues;

    @observable
    theme: SelectorValues;

    subject: Subjects;

    constructor(subject: Subjects) {

        this.subject = subject;
        this.numberInKim = new SelectorValues();
        this.theme = new SelectorValues();
        this.numberWithThemesMap = [];
        this.dictionariesService = new DictionariesService();

        makeAutoObservable(this);
    }

    @action
    loadDictionaries = async () => {
        return this.dictionariesService.getNumbersWithThemes(
            this.subject,
            (data) => {
                this.numberWithThemesMap = data;
                this.numberInKim.setValues(
                    this.numberWithThemesMap.map((v) => { return { id: v.id, name: v.name } as SelectorItem })
                );
            });
    }

    @computed
    isNotLoaded() {
        return this.numberWithThemesMap.length === 0;
    }

    @action
    selectNumberInKim(value: string) {
        this.numberInKim.selectItem(value);
        this.theme.setValues(
            this.numberWithThemesMap.filter(v => v.id === value).map((d) => d.items)[0]
        );
        this.theme.selectFirst();
    }

    @action
    reset(): void {
        this.numberInKim.selectItem(this.numberWithThemesMap[0]?.id);
        this.theme.setValues(this.numberWithThemesMap[0]?.items);
    }
}